<script>
  import Section from '../components/Section.svelte';
  import Panel from '../components/Panel.svelte';
  import Alert from '../components/Alert.svelte';
  import Button from '../components/Button.svelte';
  import HelpDrawer from '../components/HelpDrawer.svelte';
  import { signIn, session, institution } from '../lib/session.svelte.js';
  import { go } from '../lib/nav.svelte.js';
  import { HELP } from '../lib/help.js';

  let email = $state('');
  let password = $state('');
  let busy = $state(false);
  let error = $state(null);

  async function submit(event) {
    event.preventDefault();
    busy = true;
    error = null;
    try {
      await signIn(email, password);
      password = '';
      go('overview');
    } catch (e) {
      error = e.message;
    } finally {
      busy = false;
    }
  }
</script>

<HelpDrawer {...HELP.login} />

<h1 class="wf2-title wf2-title-level-1">Sign in</h1>

<Section title={institution().name}>
  <Panel>
    {#if institution().tagline}<p class="wf2-text">{institution().tagline}</p>{/if}
    <form class="login-form" onsubmit={submit}>
      <label class="wf2-field">Email
        <input class="wf2-control" type="email" autocomplete="username" required bind:value={email} />
      </label>
      <label class="wf2-field">Password
        <input class="wf2-control" type="password" autocomplete="current-password" required bind:value={password} />
      </label>
      {#if error}<Alert title="Not signed in" variant="danger"><p class="wf2-text">{error}</p></Alert>{/if}
      <div><Button variant="primary" type="submit" disabled={busy}>{busy ? 'Signing in…' : 'Sign in'}</Button></div>
    </form>
    <p class="wf2-caption">
      This signs you in to your institution's SolidShare, not to a Solid
      identity: your institution has one WebID, held by the backend, that
      partners grant access to. Ask your SolidShare operator for a login.
    </p>

    {#if session.error}
      <Alert title="Backend unreachable" variant="danger">
        <p class="mono">{session.error}</p>
        <p class="wf2-text">
          The app backend holds this institution's credential and does all Pod
          access. Check that this instance is running
          (<code class="mono">./ops/solidshare status local</code>).
        </p>
      </Alert>
    {:else if session.health}
      <Alert title="Backend connected" variant="info">
        <p class="wf2-text">
          Acting as <code class="mono">{session.health.actingAs}</code> via held
          client credentials. No token ever reaches this browser.
        </p>
      </Alert>
    {/if}
  </Panel>
</Section>

<style>
  .login-form {
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
    max-width: 360px;
    margin: var(--space-3) 0;
  }
</style>
